export default __webpack_public_path__ + "static/media/logo.791daeb7.svg";